import { APP_ENV } from '@/common/const/env.const'

export const APP_CONFIG = {
  OPERATOR: 'PLUS',
  [APP_ENV.development]: {
    API: '',
    SENTRY: '',
    CARD_WIDGET_URL: 'https://testcards.autopay.eu/widget-new/plus'
  },
  [APP_ENV.production]: {
    API: '',
    SENTRY: 'https://c07a6f32d2624df4b2fab99e02dd7154@error.blue.pl/115',
    CARD_WIDGET_URL: 'https://cards.autopay.eu/widget-new/plus'
  }
}
